function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import { LargeProductSquare } from "../../Square/LargeProductSquare/LargeProductSquare";
import { MatchHeight } from "../../Utility/MatchHeight/MatchHeight";
import { Text } from "../../Text/Text/Text";
import styles from "./LargeProductSquareSlice.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LargeProductSquareSlice = function LargeProductSquareSlice(_ref) {
  var _ref$productSquares = _ref.productSquares,
    productSquares = _ref$productSquares === void 0 ? [] : _ref$productSquares,
    _ref$footnote = _ref.footnote,
    footnote = _ref$footnote === void 0 ? '' : _ref$footnote;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [/*#__PURE__*/_jsx(MatchHeight, {
      children: /*#__PURE__*/_jsx("div", {
        className: styles.items,
        children: productSquares === null || productSquares === void 0 ? void 0 : productSquares.map(function (item, key) {
          return /*#__PURE__*/_jsx(LargeProductSquare, _objectSpread({
            className: styles.item
          }, item), key);
        })
      })
    }), footnote && /*#__PURE__*/_jsx("div", {
      className: styles.footnote,
      children: /*#__PURE__*/_jsx(Text, {
        typog: "captionSmall",
        children: footnote
      })
    })]
  });
};